export default __webpack_public_path__ + "static/media/avasta.568a19c2.eot";